<template>
<div>
    <div class="el-left-logo"
        v-if="config.logo && project != 'outlet' && project != 'wwka'"
      >
          <img :src="config.logo"/><em v-if="sidebar.opened">{{config.titleZh}}</em>
      </div>
      <div class="outlet" v-if="project === 'outlet'"></div>
      <div class="wwka" v-if="project === 'wwka'"></div>
      <div class="search">
        <el-input v-if="config.menuSearch" placeholder="请输入菜单名称搜索" v-model="filterKey">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
  <scroll-bar class="biScrollBar">
    <el-menu ref="menu" mode="vertical" :default-active="$route.path" :collapse="isCollapse" background-color="#28323d" text-color="#d6d6d6" active-text-color="#00a0e9">
      <sidebar-item :filterKey="filterKey" :config="config" :routes="permission_routers" @openMenuIndex="openMenuIndex"></sidebar-item>
    </el-menu>
  </scroll-bar>
  </div>
</template>

<script>
// const config = require('@/_app/' + process.env.PROJECT + '/src/config/index').default
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar',
      'config'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  data() {
    return {
      project: '',
      filterKey: ''
    }
  },
  methods: {
    openMenuIndex(index) {
      try {
        if (index) {
          this.$refs['menu'].open(index)
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  created() {
    this.project = process.env.PROJECT
    this.$eventBus.$on('open-menu-index', (index) => {
      this.openMenuIndex(index)
    })
  },
  destroyed() {
    this.$eventBus.$off('open-menu-index')
  }
}
</script>

<style lang="scss" scoped>
  .outlet {
    width: 220px;
    height: 72px;
    background: url('../../../../assets/image/logo.jpg') no-repeat;
    background-size: 220px 72px;
  }

  .hideSidebar .outlet {
    width:36px;
    height:36px;
    background: url('../../../../assets/image/logo_small.png') no-repeat center;
    background-size:23px 23px;
  }
   .wwka {
     width: 220px;
     height: 72px;
     background: url('../../../../../static/wwka/logo_wwka_small.png') no-repeat;
     background-size: 220px 72px;
   }
   .hideSidebar .wwka {
    width:36px;
    height:36px;
    background: url('../../../../../static/wwka/logo_wwka_small.png') no-repeat center;
    background-size:23px 23px;
  }
  .hideSidebar .search {
    display: none;
  }
   .search {
     background-color: #4097d9;
     text-align: center;
     padding-top: 11px;
     .el-input {
       width: 198px;
     }
   }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue